<div class="page-container">
  <div class="page-header">
    <h1>My Wishlist</h1>
    <p>Events you have saved for later</p>
  </div>

  <nz-spin [nzSpinning]="loading">
    <div *ngIf="wishlistItems.length > 0; else noItems" class="wishlist-grid">
      <div *ngFor="let item of wishlistItems" class="wishlist-card">
        <div class="wishlist-image" *ngIf="item.productImageFileName">
          <img
            [src]="getImageUrl(item)"
            [alt]="item.productName"
            width="400"
            height="200"
            loading="lazy"
          />
        </div>
        <div class="wishlist-image placeholder" *ngIf="!item.productImageFileName">
          <i nz-icon nzType="picture" aria-hidden="true"></i>
        </div>

        <div class="wishlist-body">
          <h3 class="wishlist-name">{{ item.productName }}</h3>
          <div class="wishlist-meta">
            <span class="wishlist-ticket-type" *ngIf="item.ticketTypeName">
              <i nz-icon nzType="tag" aria-hidden="true"></i> {{ item.ticketTypeName }}
            </span>
            <span class="wishlist-date" *ngIf="item.eventDate">
              <i nz-icon nzType="calendar" aria-hidden="true"></i> {{ item.eventDate | date:'mediumDate' }}
            </span>
            <span class="wishlist-status" *ngIf="item.eventStatus" [ngClass]="'es-' + item.eventStatus?.toLowerCase()">
              {{ item.eventStatus }}
            </span>
          </div>
          <div class="wishlist-actions">
            <button
              nz-button
              nzType="primary"
              nzSize="small"
              [nzLoading]="isAddingToCart(item.uid)"
              [disabled]="item.eventStatus !== 'OPEN'"
              (click)="buyTicket(item)"
            >
              <i nz-icon nzType="shopping-cart" aria-hidden="true"></i> Add to Cart
            </button>
            <button
              nz-button
              nzType="text"
              nzSize="small"
              nzDanger
              nz-popconfirm
              nzPopconfirmTitle="Remove from wishlist?"
              (nzOnConfirm)="removeItem(item)"
            >
              <i nz-icon nzType="delete" aria-hidden="true"></i> Remove
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noItems>
      <div class="empty-state">
        <div class="empty-icon">
          <i nz-icon nzType="heart" aria-hidden="true"></i>
        </div>
        <h3 class="empty-title">Your Wishlist Is Empty</h3>
        <p class="empty-desc">Browse events and save the ones you are interested in.</p>
        <a nz-button nzType="primary" routerLink="/events">Browse Events</a>
      </div>
    </ng-template>
  </nz-spin>
</div>


